module.exports = __webpack_public_path__ + "static/media/ui_ux_design.f740a73c.svg";